const MessagePopup = ({ open, setOpen, children, containerClassName }) => {
  return (
    <>
      {open && (
        <>
          <div
            className="fixed top-0 left-0 w-full h-full bg-[#00000094] z-[99999]"
            onClick={() => setOpen(false)}
          ></div>
          <div
            className={`
              fixed flex flex-col items-center justify-center p-8 md:min-w-[400px] min-w-[300px] z-[99999]
              -translate-x-1/2 -translate-y-1/2 top-1/2 left-1/2 rounded-2xl
              bg-mainBg text-white
              ${containerClassName}
            `}
          >
            {children}
          </div>
        </>
      )}
    </>
  );
};

export default MessagePopup;
